import React, { useState, useMemo } from "react";

import { ContactProfileFaqResult } from "@/app/pages/contactDirectory/interface";
import { isNotUndefined } from "@/shared/FunctionCore";
import Paper from "@/app/pages/contactProfile/Paper";
import ProfileCard from "@/components/cards/ProfileCard";
import "@/app/pages/contactProfile/styles/ContactProfileColleaguesStyles.scss";

type ContactProfileColleaguesFragmentComponentProps = ContactProfileFaqResult;

export const createContactProfileUrl = (url: string): string => "contact-profile." + url + ".html";

const ContactProfileColleagues = ({
		contactPeersData,
		contactProfilePageData,
		hooversSignupPath	
}: ContactProfileColleaguesFragmentComponentProps) => {
	const {
		colleagues,
		organizationName,
		success,
		totalColleagues
	} = contactPeersData;

	const {
		contact,
		contactCompanyProfileHref
	} = contactProfilePageData;

	const {
		familyName,
		givenName
	} = contact;

	const [showModal, setShowModal] = useState(false);

	const companyProfileUrl = useMemo(() =>
	"/business-directory/company-profiles" +
	contactCompanyProfileHref +
	".html"
, [contactProfilePageData.contactCompanyProfileHref])

	const onClickModalButton = (type: "close" | "open") => setShowModal(type === "open");

	return success === true && isNotUndefined(colleagues) && colleagues.length > 0 ? (
		<Paper
			title={`${givenName} ${familyName}'s Colleagues`}
			onClickModalButton={onClickModalButton}
			blockName="colleagues"
      blockId="colleagues-block"
			showModal={showModal}
		>
			<div className="row colleague-overview">
				<div className="col-md-6 col-xs-12">
					Colleagues who work at
					{" "}
					<a
						className="ContactProfileColleaguesFragmentComponentOrganizationNameLink contact-company link-with-underline"
						href={companyProfileUrl}>
						{organizationName}
					</a>
				</div>

				<div className="col-md-6 hidden-xs hidden-sm text-right">
					{isNotUndefined(totalColleagues) && totalColleagues > 4 ? (
						<a
							className="ContactProfileColleaguesFragmentComponentViewAllLinkTop viewAllColleagues view-all-colleagues suppress-ms-ext-icon"
							onClick={() => onClickModalButton("open")}>
							View all
							{" "}

							{totalColleagues}

							{" "}
							of

							{" "}

							{givenName}

							{" "}

							{familyName}

							&apos;s colleagues*

							<span className="right-arrow" />
						</a>
					) : (
						<></>
					)}
				</div>
			</div>

			<div className="row colleague-cards-wrap">
				{colleagues.map((ba, nu) => {
					const profileCardProps = {
						...ba,
						url: createContactProfileUrl(ba.url),
						onClickModalButton
					}

					return (
						<div className="col-md-3 col-xs-12" key={nu}>
							<ProfileCard {...profileCardProps} />
						</div>
					)}
				)}
			</div>

			<div className="row">
				<div className="col-xs-12 hidden-md hidden-lg">
					{isNotUndefined(totalColleagues) && totalColleagues > 4 ? (
						<a
							className="ContactProfileColleaguesFragmentComponentViewAllLinkBottom view-all-colleagues btn button-primary suppress-ms-ext-icon"
							href={hooversSignupPath}>
							View all
							{" "}

							{totalColleagues}

							{" "}
							of

							{" "}

							{givenName}

							{" "}

							{familyName}
							&apos;s colleagues*
						</a>
					) : (
						<></>
					)}
				</div>
			</div>

			<div className="row">
				<div className="col-xs-12 disclaimer-text">
					*Contacts counts are estimates and may differ from the actual number of contacts available in D&B Hoovers.
				</div>
			</div>

		</Paper>
	) : <></>;
};

export default ContactProfileColleagues;
